
import { defineComponent } from 'vue';
import MainLogo from '@/layout/header/partials/MainLogo.vue';

export default defineComponent({
  components: {
    MainLogo,
  },
});
